import { render, staticRenderFns } from "./AiSwitch.vue?vue&type=template&id=39c4cf6a&scoped=true&"
import script from "./AiSwitch.vue?vue&type=script&lang=js&"
export * from "./AiSwitch.vue?vue&type=script&lang=js&"
import style0 from "./AiSwitch.vue?vue&type=style&index=0&id=39c4cf6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c4cf6a",
  null
  
)

export default component.exports